import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * ProtectedRoute
 * Checks if the user has a valid eSignet session by calling /auth/user.
 * If not authenticated → redirects to /login.
 * Shows a full-screen spinner while checking.
 */
export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState("checking"); // "checking" | "ok" | "redirect"

  useEffect(() => {
    fetch(`${BACKEND_URL}/auth/user`, { credentials: "include" })
      .then((res) => {
        // 401 means no session
        if (res.status === 401) {
          setStatus("redirect");
          return;
        }
        return res.json().then((data) => {
          if (data.success) {
            setStatus("ok");
          } else {
            setStatus("redirect");
          }
        });
      })
      .catch(() => setStatus("redirect"));
  }, []);

  if (status === "checking") {
    return (
      <div style={spinnerStyle}>
        <div style={dotStyle} />
        <p style={textStyle}>Verifying session…</p>
      </div>
    );
  }

  if (status === "redirect") {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// ── Minimal inline styles ──────────────────────────────────────────────────
const spinnerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  background: "#f8fafc",
  gap: "16px",
};

const dotStyle = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  border: "4px solid #e2e8f0",
  borderTopColor: "#1e293b",
  animation: "spin 0.8s linear infinite",
};

const textStyle = {
  fontSize: "14px",
  color: "#64748b",
  fontFamily: "'Inter', 'Segoe UI', sans-serif",
};

// inject keyframe once
const styleTag = document.createElement("style");
styleTag.textContent = `@keyframes spin { to { transform: rotate(360deg); } }`;
document.head.appendChild(styleTag);
